import React from 'react';
import { Box, Text, VStack, Spinner, Center } from '@chakra-ui/react';
import Chart from 'react-apexcharts';

const TaskStatus = ({ data, loading }) => {

  // ✅ Extract issueByStatus from parent dashboard data
  const raw = Array.isArray(data?.issueByStatus)
    ? data.issueByStatus
    : [];

  const map = raw.reduce((acc, item) => {
    acc[item.issue_status] = item.count;
    return acc;
  }, {});

  const todoCount       = map['TO DO'] || 0;
  const inProgressCount = map['IN PROGRESS'] || 0;
  const reviewCount     = map['REVIEW'] || 0;
  const doneCount       = map['DONE'] || 0;

  const total = todoCount + inProgressCount + doneCount + reviewCount || 1;

  const chartData = {
    series: [
      Math.round((todoCount / total) * 100),
      Math.round((inProgressCount / total) * 100),
      Math.round((reviewCount / total) * 100),
      Math.round((doneCount / total) * 100),
    ],
    labels: ['To Do', 'In Progress', 'Review', 'Done'],
    counts: [todoCount, inProgressCount, reviewCount, doneCount],
  };

  const options = {
    chart: {
      type: 'donut',
      toolbar: { show: false },
    },
    labels: chartData.labels,
    colors: ['#EF4444', '#F59E0B', '#10B981', '#2e51eb'],
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(1)}%`,
      style: {
        fontSize: '12px',
        fontWeight: '600',
        colors: ['#fff'],
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          labels: { show: false },
        },
      },
    },
    legend: {
      show: true,
      position: 'right',
      horizontalAlign: 'center',
      fontSize: '12px',
      fontWeight: 500,
      markers: {
        width: 12,
        height: 12,
        radius: 3,
      },
      itemMargin: {
        vertical: 4,
      },
      formatter: (seriesName, opts) => {
        const index = opts.seriesIndex;
        const count = chartData.counts[index] || 0;
        const percentage = chartData.series[index] || 0;
        return `${seriesName}: ${count} (${percentage}%)`;
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (value, { seriesIndex }) => {
          const count = chartData.counts[seriesIndex] || 0;
          return `${count} tasks (${value}%)`;
        },
      },
    },
    stroke: {
      width: 2,
      colors: ['#fff'],
    },
  };

  if (loading) {
    return (
      <Center h="full">
        <Spinner size="lg" />
      </Center>
    );
  }

  if (chartData.series.every(val => val === 0)) {
    return (
      <VStack align="stretch" spacing={2}>
        <Text fontSize="md" fontWeight="semibold" mb={0}>
          Task By Status
        </Text>
        <Box
          bg="white"
          borderRadius="lg"
          p={6}
          boxShadow="sm"
          borderWidth="1px"
          borderColor="gray.200"
             h="310px"
        >
          <Center h="full">
            <Text color="gray.500" mb={0}>
              No data available
            </Text>
          </Center>
        </Box>
      </VStack>
    );
  }

  return (
    <VStack align="stretch" spacing={2}>
      <Text fontSize="md" fontWeight="semibold" mb={0}>
        Task By Status
      </Text>
      <Box
        bg="white"
        borderRadius="lg"
        p={6}
        boxShadow="sm"
        borderWidth="1px"
        borderColor="gray.200"
        h="310px"
      >
        <Chart
          options={options}
          series={chartData.series}
          type="donut"
          height={280}
        />
      </Box>
    </VStack>
  );
};

export default TaskStatus;